import camelCase from 'lodash/camelCase';
import { LazyAtlassianNavigation } from '@atlassian/jira-atlassian-navigation/src/async';
import { ROUTE_NAMES_SOFTWARE_SUMMARY } from '@atlassian/jira-common-constants/src/spa-routes';
import { componentWithFG } from '@atlassian/jira-feature-gate-component';
import { MENU_ID } from '@atlassian/jira-navigation-apps-common/src/constants.tsx';
import AsyncSidebarNextGen from '@atlassian/jira-navigation-apps-sidebar-next-gen/src/async';
import { createEntry } from '@atlassian/jira-route-entry';
import {
	getNavigationResources,
	getNavigationSidebarProjectResource,
} from '@atlassian/jira-router-resources-navigation';
import ErrorPagesNotFound from '@atlassian/jira-router-routes-common/src/ui/error-pages/not-found/index.tsx';
import { softwareSummaryRoute } from '@atlassian/jira-router-routes-software-summary-routes';
import { AsyncHorizontalSoftwareProjectNav } from '@atlassian/jira-software-horizontal-nav/src/async.tsx';
import { softwareProjectLayout } from '@atlassian/jira-software-project-layout';
import type { Route } from '@atlassian/react-resource-router';
import { SummaryPage, LazySummaryView } from './ui';

export const softwareSummaryRouteEntry: Route = createEntry(softwareSummaryRoute, () => ({
	ufoName: 'next-gen-summary',
	component: componentWithFG('enable_jsw_summary_page', SummaryPage, ErrorPagesNotFound),
	layout: softwareProjectLayout,
	navigation: {
		menuId: MENU_ID.PROJECTS,
		sidebar: AsyncSidebarNextGen,
		horizontal: AsyncHorizontalSoftwareProjectNav,
		onlyShowHorziontalOnNav4: true,
	},
	resources: [...getNavigationResources(), ...getNavigationSidebarProjectResource()],
	forPaint: [LazyAtlassianNavigation, LazySummaryView],
	meta: {
		reporting: {
			id: ROUTE_NAMES_SOFTWARE_SUMMARY,
			packageName: camelCase(ROUTE_NAMES_SOFTWARE_SUMMARY),
			teamName: 'Helios - Reports',
		},
	},
}));
